import { ArrowUpRightIcon } from "lucide-react";

import { Row, Text } from "@/components";
import { JobOverviewDialog } from "@jobs/JobOverviewDialog";
import { Button } from "@/components/ui/button";

import { useGetJob } from "@/hooks/queries/useGetJob";

export const RecommendedJobTitlePreview = ({
  companyId,
  jobId,
  title,
}: {
  companyId: string;
  jobId: string;
  title: string;
}) => {
  /* Handlers */
  const handleOpenJob = () => {
    window.open(`/companies/${companyId}/jobs/${jobId}`, "_blank");
  };

  /* Render */
  const render = () => {
    return (
      <Row className="min-w-0 items-center gap-1.5">
        <Text className="truncate font-medium text-slate-900">{title}</Text>
        <Button
          className="h-6 w-6 shrink-0 text-slate-500 hover:text-primary-700"
          onClick={(event) => {
            event.stopPropagation();
            handleOpenJob();
          }}
          size="icon"
          title="Open job"
          type="button"
          variant="ghost"
        >
          <ArrowUpRightIcon className="h-3.5 w-3.5" />
        </Button>
      </Row>
    );
  };

  return render();
};

export const RecommendedJobPreviewDialog = ({
  companyId,
  companyName,
  jobId,
  onOpenChange,
}: {
  companyId: string;
  companyName: string;
  jobId: string;
  onOpenChange: (open: boolean) => void;
}) => {
  /* Database CRUD Operations */
  // Read
  const { data: job } = useGetJob({ companyId, jobId });

  /* Render */
  const render = () => {
    if (!job) return null;

    return (
      <JobOverviewDialog
        companyName={companyName}
        job={job}
        onOpenChange={onOpenChange}
        open
      />
    );
  };

  return render();
};
